import { render, staticRenderFns } from "./ForgetPasswordForm.vue?vue&type=template&id=1c492ef9&scoped=true&lang=html&"
import script from "./ForgetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswordForm.vue?vue&type=style&index=0&id=1c492ef9&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c492ef9",
  null
  
)

export default component.exports